import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
    Card,
    CardContent,
} from '@material-ui/core';

import iconWhatsapp from '../../../../../images/social/wapp.png';
import iconFacebook from '../../../../../images/social/facebook.png';
import iconTwitter from '../../../../../images/social/twitter.png';
import iconLinkedin from '../../../../../images/social/linkedin.png';

import CustomIcon from '../CustomIcon';
import { defaultPaperPadding } from '../../../../../config';

const UsersByDevice = props => {
    const { sharegraph, currentTotal, oldTotal, className, ...rest } = props;

    const percent = Math.abs(parseInt(((currentTotal - oldTotal) / (oldTotal > 0 ? oldTotal : 1)) * 100).toFixed(3)).toString()

    const theme = useTheme();

    const whatsapp = props.whatsapp;
    const facebook = props.facebook;
    const linkedin = props.linkedin;
    const twitter = props.twitter;

    const sharesTotal = whatsapp + facebook + linkedin + twitter;

    //let v = (vlor / valorTotal) * 100; 

    const percentWhatsapp = whatsapp > 0 ? ((whatsapp / sharesTotal) * 100).toFixed(0) : 0;
    const percentFacebook = facebook > 0 ? ((facebook / sharesTotal) * 100).toFixed(0) : 0;
    const percentLinkedin = linkedin > 0 ? ((linkedin / sharesTotal) * 100).toFixed(0) : 0;
    const percentTwitter = twitter > 0 ? ((twitter / sharesTotal) * 100).toFixed(0) : 0;


    let valoresAgregadores = [whatsapp, facebook, linkedin, twitter]

    const data = {
        datasets: [
            {
                data: valoresAgregadores,
                backgroundColor: [
                    '#FFD059',
                    '#FFA400',
                    '#FF7509',
                    '#2893A1'
                ],
                borderWidth: 1,
                borderColor: [
                    '#FFD059',
                    '#FFA400',
                    '#FF7509',
                    '#2893A1'
                ],
                hoverBorderColor: theme.palette.white
            }
        ],
        labels: ['Whatsapp', 'Facebook', 'Linkedin', 'Twitter']
    };

    const options = {
        legend: {
            display: true,
            position: 'left',
            align: 'end',
            onHover: (evt) => {
                const leftSpacing = evt.clientX
                const topSpacing = evt.clientY

                const tooltipDiv = document.getElementById('customTooltip')
                tooltipDiv.style.left = (leftSpacing + 10) + 'px'
                tooltipDiv.style.top = (topSpacing - 3) + 'px'
                tooltipDiv.style.padding = '5px'

                tooltipDiv.innerText = 'Clique na leganda para tirar o canal do filtro'
            },
            onLeave: (evt) => {
                const tooltipDiv = document.getElementById('customTooltip')
                tooltipDiv.innerText = ''
                tooltipDiv.style.padding = '0px'
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        // cutoutPercentage: 80,
        layout: { padding: 0 },
        centerText: {
            text: sharesTotal
        },
        tooltips: {
            enabled: true,
            mode: 'index',
            intersect: false,
            borderWidth: 1,
            borderColor: theme.palette.divider,
            backgroundColor: theme.palette.white,
            titleFontColor: theme.palette.text.primary,
            bodyFontColor: theme.palette.text.secondary,
            footerFontColor: theme.palette.text.secondary,
        }
    };

    const devices = [
        {
            title: 'Whatsapp',
            value: percentWhatsapp,
            icon: <CustomIcon path={iconWhatsapp} />,
            color: '#47b821'
        },
        {
            title: 'Facebook',
            value: percentFacebook,
            icon: <CustomIcon path={iconFacebook} />,
            color: '#29599b',
        },
        {
            title: 'Linkedin',
            value: percentLinkedin,
            icon: <CustomIcon path={iconLinkedin} />,
            color: '#387bbd',
        },
        {
            title: 'Twitter',
            value: percentTwitter,
            icon: <CustomIcon path={iconTwitter} />,
            color: '#50aef0',
        }
    ];

    return (
        <Card
            style={{ height: '100%', borderRadius: '15px', display: 'flex', flexDirection: 'column', padding: defaultPaperPadding }}
        >
            <div className={'paperData'}>
                <div style={{ padding: '10px 20px', color: 'grey' }} elevation={3}>
                    <h3>Compartilhamentos</h3>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h1 style={{ padding: '10px 0', marginRight: '5px' }}>{sharesTotal}</h1>
                        <h2 style={{ color: percent == 0 ? 'grey' : percent > 0 ? 'green' : 'red' }}>{percent == 0 ? '' : percent > 0 ? '+' : ''}{percent}%</h2>
                    </div>
                    <h3 style={{ color: 'lightgrey' }}>Número de vezes que seu conteúdo foi compartilhado nas redes sociais</h3>
                </div>
            </div>
            <CardContent style={{ height: '100%', width: '100%' }}>
                <div style={{ height: '100%', width: '100%' }}>
                    <Doughnut
                        data={data}
                        options={options}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

UsersByDevice.propTypes = {
    className: PropTypes.string
};




export default UsersByDevice;